import { queryClient } from '@/services/queryClient';

export function invalidateCashSessionQueries(id?: string) {
  queryClient.invalidateQueries(['cash-sessions']);
  queryClient.invalidateQueries(['cash-session-current']);
  queryClient.invalidateQueries(['cash-session']);
  queryClient.invalidateQueries(['cash-session-summary']);

  if (id) {
    queryClient.invalidateQueries(['cash-session', id]);
    queryClient.invalidateQueries(['cash-session-summary', id]);
  }
}
